import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegrationsService } from '../../../core/services/integrations.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { switchMap, takeWhile } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { timer, Subscription, of } from 'rxjs';

@Component({
  selector: 'app-add-store-pop-up',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-store-pop-up.component.html',
  styleUrl: './add-store-pop-up.component.scss'
})
export class AddStorePopUpComponent implements OnInit, OnChanges , AfterViewInit , OnDestroy {
  // @Input('open') open = false;
  // @Output() dismissEvent = new EventEmitter<boolean>();
  @ViewChild('AddStore') AddStore: ElementRef | undefined;
  @ViewChild('goToShopifyStore') goToShopifyStore: ElementRef | undefined;

  private checkerSubscription: Subscription;

  projectId:string;

  COOKIE_TOKEN_NAME = 'x-token';

  constructor(
    private router: Router,
    private cookie:CookieService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private integrationsService: IntegrationsService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((val:any)=>{
      this.projectId = val.params['pid'];
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Handle route change here
        const routes =  event.url.split('/')
        if(routes[1] === 'projects'){
          this.projectId = routes[2];
        }
      }
    });
  }

  ngAfterViewInit() {
    this.integrationsService.registerTemplate('AddStore', this.AddStore);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.open.currentValue) {
      this.displayModal(this.AddStore);
    }
  }

  ngOnDestroy(): void {
    if (this.checkerSubscription) {
      this.checkerSubscription.unsubscribe();
    }
  }

  startChecking() {
    this.checkerSubscription = timer(0,5000)
      .pipe(
        switchMap(() => of(this.cookie.check(this.COOKIE_TOKEN_NAME))),
        takeWhile(value => value === false , true)
      )
      .subscribe((value) => {
        if (value) {
          this.navigateToCreateIntegrationAndDismissModal('shopify');
        }
      });
  }

  displayModal(modal){
    this.modalService.open(modal, { centered: true, windowClass: 'modal-holder' , size: "md" ,backdrop: 'static', keyboard: false  })
  }

  goToAddStore(storeType:string){
    if(storeType == 'custom'){
      this.navigateToCreateIntegrationAndDismissModal(storeType);
    }
    else if(storeType == 'shopify'){
      if(this.getTokenFromCookie()){
        this.navigateToCreateIntegrationAndDismissModal(storeType);
      }
      else{
        this.displayModal(this.goToShopifyStore);
        this.startChecking();
      }
    }
  }

  navigateToCreateIntegrationAndDismissModal(storeType:string){
    this.router.navigate([`/projects/${this.projectId}/stores/add`],{ queryParams: { type: storeType }});
    this.modalService.dismissAll();
  }

  goToMyStore(){
    window.open("https://apps.shopify.com/kainic-plugin", "_blank");
  }

  getTokenFromCookie(){
    return this.cookie.get(this.COOKIE_TOKEN_NAME);
  }

  deleteTokenFromCookie(){
    this.cookie.delete(this.COOKIE_TOKEN_NAME, '/');
  }

  closePopup(){
    this.modalService.dismissAll();
    this.deleteTokenFromCookie();
  }

}
